<div *ngIf="control && errorMessage !== null" id="control-errors" [class]="'text-danger caption-c2 mt-1 max-w-md w-full flex-1'" [attr.data-test]="'error-' + errorMessage">{{ ('formErrors.') + errorMessage | translate }}</div>
